<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfm" id="rloi"><a class="xref" href="#/wsumidejewski0008#loi">List of Illustrations</a></p>
<p class="tocfm" id="racknow"><a class="xref" href="#/wsumidejewski0009#acknow">Acknowledgments</a></p>
<p class="tocf" id="rch01"><a class="xref" href="#/wsumidejewski0010#ch01">Carrie On: An Introduction</a></p>
<p class="tocau">Linda Mizejewski and Tanya D. Zuk</p>
<p class="tocpt" id="rpt01"><a class="xref" href="#/wsumidejewski0011#pt01">I. Leia/Carrie</a></p>
<p class="toc" id="rch02"><a class="xref" href="#/wsumidejewski0012#ch02">Who Owns Carrie Fisher? A Complicated Embodiment of Manufactured Commodity and Avatar of Resistance</a></p>
<p class="tocau">Jennifer M. Fogel</p>
<p class="toc" id="rch03"><a class="xref" href="#/wsumidejewski0013#ch03">Gatekeeping the Past: Fandom and the Gendered Cultural Memory of <i>Star Wars</i></a></p>
<p class="tocau">Philipp Dominik Keidl</p>
<p class="toc" id="rch04"><a class="xref" href="#/wsumidejewski0014#ch04">Harvesting the Celebrity Interface: Carrie Fisher, Virtual Performance, and Software Stars</a></p>
<p class="tocau">Andrew Kemp-Wilcox</p>
<p class="toc" id="rch05"><a class="xref" href="#/wsumidejewski0015#ch05">“Carrie Fisher Sent Me”: Gendered Political Protest, <i>Star Wars</i>, and the Women’s March</a></p>
<p class="tocau">Tanya D. Zuk</p>
<p class="tocpt" id="rpt02"><a class="xref" href="#/wsumidejewski0016#pt02">II. Carrie/Leia</a></p>
<p class="toc" id="rch06"><a class="xref" href="#/wsumidejewski0017#ch06">Comedy from the Edge: Carrie Fisher’s Autobiographical Writing</a></p>
<p class="tocau">Linda Mizejewski</p>
<p class="toc" id="rch07"><a class="xref" href="#/wsumidejewski0018#ch07">Postcards from the Valley of the Broads: Carrie Fisher, Jacqueline Susann, and Feminist Camp Authorship</a></p>
<p class="tocau">Ken Feil</p>
<p class="toc" id="rch08"><span aria-label="viii" class="page" id="pviii" role="doc-pagebreak"></span><a class="xref" href="#/wsumidejewski0019#ch08">“My body hasn’t aged as well as I have. Blow us”: Carrie Fisher and the Unruly Aging Actress</a></p>
<p class="tocau">Kristen Anderson Wagner</p>
<p class="toc" id="rch09"><a class="xref" href="#/wsumidejewski0020#ch09">“Stay afraid, but do it anyway”: Carrie Fisher’s Mental Health Advocacy</a></p>
<p class="tocau">Cynthia A. Hoffner and Sejung Park</p>
<p class="toc" id="rch10"><a class="xref" href="#/wsumidejewski0021#ch10">Threshold Guardian to Space Mom: Here, but for the Sake of Carrie, Go I</a></p>
<p class="tocau">Slade Kinnecott</p>
<p class="tocbmf" id="rch11"><a class="xref" href="#/wsumidejewski0022#ch11">Appendix 1. What Would Carrie Fisher Do?</a></p>
<p class="tocau">Lindsay van Ekelenburg</p>
<p class="tocbm" id="rch12"><a class="xref" href="#/wsumidejewski0023#ch12">Appendix 2. Carrie Fisher Media Work, Appearances, and Fanworks</a></p>
<p class="tocau">Maghan Jackson</p>
<p class="tocbmf" id="rwrk_ctd"><a class="xref" href="#/wsumidejewski0024#wrk_ctd">Works Cited</a></p>
<p class="tocbm" id="rcontrib"><a class="xref" href="#/wsumidejewski0025#contrib">Contributors</a></p>
<p class="tocbm" id="rindex"><a class="xref" href="#/wsumidejewski0026#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-midejewski-0007.vue?6f43709c